import { ScrollArea, Stack, Tabs, TabsPanelProps } from '@mantine/core';
import { useResponsiveDesign } from 'hooks/use-responsive-design';

/**
 * The height of the tab panel.
 */
const HEIGHT = 'calc(100vh - 200px)';

/**
 * Parameters of the RevisionTab component.
 */
export interface RevisionTabProps extends TabsPanelProps {
  skinny?: boolean;
}

/**
 * Custom Tab panel for the electric revision form.
 */
export default function RevisionTab({ value, children, skinny = false, ...otherProps }: RevisionTabProps) {
  const { isTablet } = useResponsiveDesign();

  return (
    <Tabs.Panel value={value} h={HEIGHT} {...otherProps}>
      <ScrollArea h={HEIGHT}>
        <Stack spacing={isTablet ? 20 : 40} p={skinny ? 0 : isTablet ? 20 : 40}>
          {children}
        </Stack>
      </ScrollArea>
    </Tabs.Panel>
  );
}
